var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.011,
    height: 25.545,
    viewBox: "0 0 20.011 25.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg-svgrepo-com",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14183",
    "data-name": "Trazado 14183",
    d: "M48.6,0H32.842V25.545H52.853V4.257Z",
    transform: "translate(-32.843)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14184",
    "data-name": "Trazado 14184",
    d: "M49.254,2.129H32.842V0H48.6Z",
    transform: "translate(-32.843)",
    fill: "#fb9200"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_465",
    "data-name": "Grupo 465",
    transform: "translate(4.496 18.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14185",
    "data-name": "Trazado 14185",
    d: "M89.045,228.075a1.192,1.192,0,0,1-.191.668,1.249,1.249,0,0,1-.55.453,2.039,2.039,0,0,1-.843.162,3.414,3.414,0,0,1-.677-.057,2.507,2.507,0,0,1-.57-.2v-.973a3.248,3.248,0,0,0,.65.25,2.418,2.418,0,0,0,.619.09.6.6,0,0,0,.357-.084.26.26,0,0,0,.113-.217.239.239,0,0,0-.046-.145.533.533,0,0,0-.147-.126q-.1-.063-.538-.26a2.581,2.581,0,0,1-.593-.348,1.07,1.07,0,0,1-.293-.387,1.284,1.284,0,0,1-.1-.517,1.036,1.036,0,0,1,.406-.871,1.792,1.792,0,0,1,1.117-.312,3.135,3.135,0,0,1,1.28.29l-.335.843a2.424,2.424,0,0,0-.979-.26.51.51,0,0,0-.31.075.226.226,0,0,0-.1.185.267.267,0,0,0,.123.213,4.679,4.679,0,0,0,.668.343,1.846,1.846,0,0,1,.726.5A1.1,1.1,0,0,1,89.045,228.075Z",
    transform: "translate(-86.214 -225.202)",
    fill: "#a4a9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14186",
    "data-name": "Trazado 14186",
    d: "M124.757,225.892h1.222l-1.325,4.042h-1.286l-1.319-4.042h1.228l.55,2.049a6.235,6.235,0,0,1,.188.951q.019-.193.077-.484t.1-.456Z",
    transform: "translate(-119.031 -225.834)",
    fill: "#a4a9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14187",
    "data-name": "Trazado 14187",
    d: "M173.868,226.936h1.745v2.179a4.8,4.8,0,0,1-1.562.243,1.889,1.889,0,0,1-1.445-.542,2.17,2.17,0,0,1-.51-1.546,2.03,2.03,0,0,1,.559-1.523,2.147,2.147,0,0,1,1.565-.545,3.464,3.464,0,0,1,.72.072,3.052,3.052,0,0,1,.59.182l-.346.857a2.138,2.138,0,0,0-.959-.216.912.912,0,0,0-.74.311,1.346,1.346,0,0,0-.261.889,1.364,1.364,0,0,0,.236.864.819.819,0,0,0,.682.3,2,2,0,0,0,.448-.047v-.633h-.722v-.843Z",
    transform: "translate(-164.86 -225.202)",
    fill: "#a4a9ad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_466",
    "data-name": "Grupo 466",
    transform: "translate(3.658 8.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14188",
    "data-name": "Trazado 14188",
    d: "M79.673,106.22a1.238,1.238,0,0,1-.481,1.054,2.375,2.375,0,0,1-1.438.362,4.518,4.518,0,0,1-.837-.066,3.157,3.157,0,0,1-.648-.2v-1.014a4.273,4.273,0,0,0,.77.27,3.124,3.124,0,0,0,.754.109q.668,0,.668-.386a.323.323,0,0,0-.088-.235,1.282,1.282,0,0,0-.306-.205q-.217-.115-.579-.268a3.637,3.637,0,0,1-.762-.4,1.131,1.131,0,0,1-.354-.424,1.4,1.4,0,0,1-.111-.589,1.068,1.068,0,0,1,.465-.927,2.263,2.263,0,0,1,1.317-.328,3.74,3.74,0,0,1,1.581.354l-.37.885q-.338-.145-.631-.237a1.984,1.984,0,0,0-.6-.093q-.543,0-.543.294a.345.345,0,0,0,.175.286,4.761,4.761,0,0,0,.766.358,3.562,3.562,0,0,1,.772.4,1.178,1.178,0,0,1,.362.426A1.31,1.31,0,0,1,79.673,106.22Z",
    transform: "translate(-76.262 -102.974)",
    fill: "#fb9200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14189",
    "data-name": "Trazado 14189",
    d: "M122.181,108.475l-1.713-4.5h1.283l.869,2.562a4.568,4.568,0,0,1,.181.921h.024a4,4,0,0,1,.181-.921l.865-2.562h1.283l-1.713,4.5Z",
    transform: "translate(-116.743 -103.893)",
    fill: "#fb9200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14190",
    "data-name": "Trazado 14190",
    d: "M180.9,103.06v.623l-.7.181a1.228,1.228,0,0,1,.193.676,1.365,1.365,0,0,1-.5,1.128,2.187,2.187,0,0,1-1.4.4l-.221-.012-.181-.02a.408.408,0,0,0-.189.322q0,.266.676.265h.764a1.744,1.744,0,0,1,1.128.318,1.136,1.136,0,0,1,.388.933,1.384,1.384,0,0,1-.658,1.223,3.425,3.425,0,0,1-1.888.434,2.614,2.614,0,0,1-1.438-.328,1.041,1.041,0,0,1-.5-.919.962.962,0,0,1,.253-.68,1.439,1.439,0,0,1,.744-.39.821.821,0,0,1-.33-.263.647.647,0,0,1,.008-.817,1.721,1.721,0,0,1,.43-.336,1.207,1.207,0,0,1-.561-.491,1.493,1.493,0,0,1-.207-.8,1.4,1.4,0,0,1,.479-1.138,2.069,2.069,0,0,1,1.368-.4,3.509,3.509,0,0,1,.449.034q.259.034.332.05Zm-3.471,5.132a.444.444,0,0,0,.243.4,1.338,1.338,0,0,0,.682.145,2.415,2.415,0,0,0,1.034-.181.552.552,0,0,0,.374-.495.35.35,0,0,0-.221-.35,1.809,1.809,0,0,0-.684-.1h-.636a.962.962,0,0,0-.565.159A.489.489,0,0,0,177.433,108.193Zm.446-3.66a.915.915,0,0,0,.167.579.606.606,0,0,0,.509.213.594.594,0,0,0,.507-.213.941.941,0,0,0,.161-.579q0-.813-.668-.813T177.879,104.532Z",
    transform: "translate(-167.936 -102.976)",
    fill: "#fb9200"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14191",
    "data-name": "Trazado 14191",
    d: "M219.821,4.257h4.257L219.821,0Z",
    transform: "translate(-204.068)",
    fill: "#d1d3d3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.d5ce528e8c97924ceb5bc10378305a5a.svg";
export { ForwardRef as ReactComponent };